module.exports = __webpack_public_path__ + "fonts/opoli.8f57527.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/opoli.woff?y08y5r
// module id = 1102
// module chunks = 0